const other = [
    {
        path: '/',
        name: 'editor',
        component: () => import('@/view/EditorPano.vue')
    },
    {
        path: '/tour',
        name: 'tour',
        component: () => import('@/view/VTour.vue')
    },
    {
        path: '/pano',
        name: 'pano',
        component: () => import('@/view/VPano.vue')
    },
    {
        name: 'exception',
        path: '/exception/:msg',
        meta: {
            msg: ''
        },
        component: () => import('@/view/exception/index.vue')
    },
    {
        name: 'delete',
        path: '/delete/:msg',
        meta: {
            msg: ''
        },
        component: () => import('@/view/error-page/index.vue')
    },
    {
        path: '*',
        name: 'error_404',
        component: () => import('@/view/error-page/404.vue')
    },
    {
        path: '/update',
        component: () => import('@/view/error-page/update.vue')
    }
];

const router = [...other];

export default router;



// WEBPACK FOOTER //
// ./src/router/routers.js